import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { Tooltip } from "@air/primitive-tooltip";
import { useAirModal } from "@air/provider-modal";
import { memo } from "react";
import { ConnectedToSlackToggles } from "~/components/EditPrivateBoardModal/EditBoardModal/SlackIntegration/components/ConnectedToSlackToggles";
import { ConnectedSlackChannel } from "./ConnectedSlackChannel";
import { DeleteBoardSlackIntegrationModal } from "./DeleteBoardSlackIntegrationModal";
export const ConnectedToSlack = /*#__PURE__*/ memo((param)=>{
    let { integration, boardId, canManageSlackIntegration, onUpdate } = param;
    var _integration_coveredByBoard;
    const [showDeleteSlackIntegrationModal] = useAirModal(DeleteBoardSlackIntegrationModal);
    return /*#__PURE__*/ _jsxs("div", {
        className: "group/connected-slack-container mt-16 rounded-6 border border-grey-3 bg-grey-3 px-3 py-2 pb-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ _jsx(ConnectedSlackChannel, {
                        channelName: integration.channelName,
                        integration: integration
                    }),
                    canManageSlackIntegration && /*#__PURE__*/ _jsx(Tooltip, {
                        side: "bottom",
                        label: integration.isCoveredByAncestor && ((_integration_coveredByBoard = integration.coveredByBoard) === null || _integration_coveredByBoard === void 0 ? void 0 : _integration_coveredByBoard.title) ? "Connected via ".concat(integration.coveredByBoard.title) : undefined,
                        children: /*#__PURE__*/ _jsx(Button, {
                            appearance: "filled",
                            disabled: integration.isCoveredByAncestor,
                            className: "disabled:bg-grey-5 disabled:text-grey-11",
                            color: "grey",
                            onClick: ()=>showDeleteSlackIntegrationModal({
                                    boardId,
                                    integration
                                }),
                            children: "Disconnect"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ConnectedToSlackToggles, {
                integration: integration,
                onUpdate: onUpdate,
                canManageSlackIntegration: canManageSlackIntegration,
                boardId: boardId
            })
        ]
    });
});
ConnectedToSlack.displayName = "ConnectedToSlack";
